// TODO: import from editor-elements or thunderbolt-commons
enum ExternalComponentErrorType {
	Runtime = 'ExternalComponentRuntimeError',
	WrongExport = 'ExternalComponentWrongExportError',
	MissingExport = 'ExternalComponentMissingExportError',
	Timeout = 'ExternalComponentTimeoutError',
	Fetch = 'ExternalComponentFetchError',
	Bundling = 'ExternalComponentBundlingError',
	FileNotFound = 'ExternalComponentFileNotFoundError',
	UnsupportedBrowser = 'ExternalComponentUnsupportedBrowser',
}

export abstract class ExternalComponentRendererError extends Error {}

export class ExternalComponentWrongExportError extends ExternalComponentRendererError {
	constructor(importKey: string, modulePath: string) {
		super(`"The import key ${importKey} is invalid in ${modulePath}`)
		this.name = ExternalComponentErrorType.WrongExport
	}
}

export class ExternalComponentMissingExportError extends ExternalComponentRendererError {
	constructor(modulePath: string) {
		super(`Missing export in ${modulePath}`)
		this.name = ExternalComponentErrorType.MissingExport
	}
}

export class ExternalComponentTimeoutError extends ExternalComponentRendererError {
	constructor(message: string = 'Loading the component timed out') {
		super(message)
		this.name = ExternalComponentErrorType.Timeout
	}
}

export class ExternalComponentFetchError extends ExternalComponentRendererError {
	originalError: Error
	constructor(message: string = 'Failed to fetch the component', error: Error) {
		super(message)
		this.name = ExternalComponentErrorType.Fetch
		this.originalError = error
	}
}

export class ExternalComponentBundlingError extends ExternalComponentRendererError {
	constructor(modulePath: string, response: string) {
		super(`Failed to bundle ${modulePath} due to errors in its code.\n${response}`)
		this.name = ExternalComponentErrorType.Bundling
	}
}

export class ExternalComponentFileNotFoundError extends ExternalComponentRendererError {
	constructor(modulePath: string) {
		super(`File ${modulePath} not found`)
		this.name = ExternalComponentErrorType.FileNotFound
	}
}

export class ExternalComponentRuntimeError extends Error {
	constructor(message: string = 'React component render failed') {
		super(message)
		this.name = ExternalComponentErrorType.Runtime
	}
}

export class ExternalComponentUnsupportedBrowserError extends Error {
	constructor(message: string = 'Unsupported browser') {
		super(message)
		this.name = ExternalComponentErrorType.UnsupportedBrowser
	}
}
